import { FaPhone, FaEnvelope } from 'react-icons/fa';

import './Footer.css'

function Footer() {
    return (
      <div className="footer">
        <div id="contact">Contact Us</div>
        <div id="number"><FaPhone className="icon" /> <a href="tel:+1-647-955-7005">647-955-7005</a></div>
        <div id="email"><FaEnvelope className="icon" /> <a href="mailto:info@kriyago.com">info@kriyago.com</a></div>
      </div>
    );
  }
  
  export default Footer;